// AUTO-GENERATED — do not edit. Run: pnpm generate:tokens
// Sources: @kcftech/design-system CSS + src/styles/tokens/semantics.css

export const sdwebTokens = {
    absolute: {
        primary: 'var(--absolute-primary, #fff)',
        inverse: 'var(--absolute-inverse, #000)',
    },
    action: {
        disabledOpacity: 'var(--action-disabled-opacity, .4)',
        active: 'var(--action-active, rgb(7 20 51 / .08))',
        hover: 'var(--action-hover, rgb(7 20 51 / .04))',
        selected: 'var(--action-selected, rgb(7 20 51 / .08))',
        focus: 'var(--action-focus, rgb(7 20 51 / .1))',
        disabled: 'var(--action-disabled, rgb(7 20 51 / .28))',
        disabledBackground: 'var(--action-disabled-background, rgb(7 20 51 / .1))',
        confirm: 'var(--action-confirm, #5ab64b)',
    },
    activity: {
        lineAlarm: 'var(--activity-line-alarm, #f72f40)',
        lineWarning: 'var(--activity-line-warning, #e18428)',
        lineManual: 'var(--activity-line-manual, #0055a3)',
        lineAutomatic: 'var(--activity-line-automatic, #f7f8f9)',
        lineMachineiq: 'var(--activity-line-machineiq, #39116d)',
        lineMultiple: 'var(--activity-line-multiple, #2eb8d8)',
        lineCreationMarker: 'var(--activity-line-creation-marker, #2f3647)',
        lineCriticalAlarm: 'var(--activity-line-critical-alarm, #af202b)',
    },
    alert: {
        errorBackground: 'var(--alert-error-background, #fee6e8)',
        errorColor: 'var(--alert-error-color, #af202b)',
        infoBackground: 'var(--alert-info-background, #e3f2fd)',
        infoColor: 'var(--alert-info-color, #0055a3)',
        successBackground: 'var(--alert-success-background, #e7f4e5)',
        successColor: 'var(--alert-success-color, #117800)',
        warningBackground: 'var(--alert-warning-background, #fbedcb)',
        warningColor: 'var(--alert-warning-color, #a33c00)',
    },
    analysis: {
        markerRuler: 'var(--analysis-marker-ruler, #9298a6)',
        marker1x: 'var(--analysis-marker-1x, #9c27b0)',
        markerBpfo: 'var(--analysis-marker-bpfo, #fe5918)',
        markerBpfi: 'var(--analysis-marker-bpfi, #0070c4)',
        markerBsf: 'var(--analysis-marker-bsf, #48a748)',
        markerFtf: 'var(--analysis-marker-ftf, #f29d01)',
        marker2xlf: 'var(--analysis-marker-2xlf, #009ce1)',
        markerLf: 'var(--analysis-marker-lf, #228910)',
        markerPpf: 'var(--analysis-marker-ppf, #d10d54)',
        markerRbf: 'var(--analysis-marker-rbf, #00bcd4)',
        markerSspf: 'var(--analysis-marker-sspf, #ce4c00)',
    },
    asset: {
        normal: 'var(--asset-normal, #228910)',
        warning: 'var(--asset-warning, #e99c3d)',
        alarm: 'var(--asset-alarm, #e12635)',
        critical: 'var(--asset-critical, #af202b)',
        monitored: 'var(--asset-monitored, #0070c4)',
    },
    background: {
        paperElevation0: 'var(--background-paper-elevation-0, #fff)',
        paperElevation1: 'var(--background-paper-elevation-1, #fff)',
        paperElevation2: 'var(--background-paper-elevation-2, #fff)',
        paperElevation3: 'var(--background-paper-elevation-3, #fff)',
        paperElevation4: 'var(--background-paper-elevation-4, #fff)',
        paperElevation5: 'var(--background-paper-elevation-5, #fff)',
        paperElevation6: 'var(--background-paper-elevation-6, #fff)',
        paperElevation7: 'var(--background-paper-elevation-7, #fff)',
        paperElevation8: 'var(--background-paper-elevation-8, #fff)',
        paperElevation9: 'var(--background-paper-elevation-9, #fff)',
        paperElevation10: 'var(--background-paper-elevation-10, #fff)',
        paperElevation11: 'var(--background-paper-elevation-11, #fff)',
        paperElevation12: 'var(--background-paper-elevation-12, #fff)',
        paperElevation13: 'var(--background-paper-elevation-13, #fff)',
        paperElevation14: 'var(--background-paper-elevation-14, #fff)',
        paperElevation15: 'var(--background-paper-elevation-15, #fff)',
        paperElevation16: 'var(--background-paper-elevation-16, #fff)',
        paperElevation17: 'var(--background-paper-elevation-17, #fff)',
        paperElevation18: 'var(--background-paper-elevation-18, #fff)',
        paperElevation19: 'var(--background-paper-elevation-19, #fff)',
        paperElevation20: 'var(--background-paper-elevation-20, #fff)',
        paperElevation21: 'var(--background-paper-elevation-21, #fff)',
        paperElevation22: 'var(--background-paper-elevation-22, #fff)',
        paperElevation23: 'var(--background-paper-elevation-23, #fff)',
        paperElevation24: 'var(--background-paper-elevation-24, #fff)',
        default: 'var(--background-default, #fff)',
        subtle: 'var(--background-subtle, #eff1f3)',
        alphaDefault: 'var(--background-alpha-default, rgb(255 255 255 / .6))',
        multicolorsDefault: 'var(--background-multicolors-default, #2f3647)',
    },
    border: {
        default: 'var(--border-default, rgb(7 20 51 / .14))',
        light: 'var(--border-light, rgb(7 20 51 / .14))',
        dark: 'var(--border-dark, #c1c4cc)',
        focus: 'var(--border-focus, #0070c4)',
        error: 'var(--border-error, #e12635)',
        warning: 'var(--border-warning, #e99c3d)',
        success: 'var(--border-success, #228910)',
        info: 'var(--border-info, #0070c4)',
        subtle: 'var(--border-subtle, #a2a7b3)',
        strong: 'var(--border-strong, #63687c)',
        hover: 'var(--border-hover, rgb(7 20 51 / .24))',
    },
    button: {
        paddingNoneX: 'var(--button-padding-none-x, 0rem)',
        paddingNoneY: 'var(--button-padding-none-y, 0rem)',
        paddingCompactX: 'var(--button-padding-compact-x, 1rem)',
        paddingCompactY: 'var(--button-padding-compact-y, .5rem)',
        paddingMediumX: 'var(--button-padding-medium-x, 2rem)',
        paddingMediumY: 'var(--button-padding-medium-y, 1.4rem)',
        minWidthMedium: 'var(--button-min-width-medium, 10rem)',
        paddingLargeX: 'var(--button-padding-large-x, 3rem)',
        paddingLargeY: 'var(--button-padding-large-y, 1.8rem)',
        minWidthLarge: 'var(--button-min-width-large, 10rem)',
        borderRadius: 'var(--button-border-radius, .5rem)',
        fontSize: 'var(--button-font-size, 1.4rem)',
        iconGap: 'var(--button-icon-gap, 1rem)',
        primaryText: 'var(--button-primary-text, #fff)',
        primaryBackground: 'var(--button-primary-background, #0070c4)',
        primaryBackgroundHover: 'var(--button-primary-background-hover, #0055a3)',
        secondaryText: 'var(--button-secondary-text, #2f3647)',
        secondaryBackground: 'var(--button-secondary-background, #e0e1e5)',
        secondaryBackgroundHover: 'var(--button-secondary-background-hover, #c1c4cc)',
        tertiaryText: 'var(--button-tertiary-text, #2f3647)',
        tertiaryBackground: 'var(--button-tertiary-background, #fff)',
        tertiaryBackgroundHover: 'var(--button-tertiary-background-hover, #e0e1e5)',
        tertiaryBackgroundDisabled: 'var(--button-tertiary-background-disabled, #fff)',
        tertiaryShadow: 'var(--button-tertiary-shadow, 0 0 4px 0 rgb(7 20 51 / .08))',
        subtleText: 'var(--button-subtle-text, #2f3647)',
        subtleTextHover: 'var(--button-subtle-text-hover, #2f3647)',
        subtleBackground: 'var(--button-subtle-background, transparent)',
        subtleBackgroundHover: 'var(--button-subtle-background-hover, #e0e1e5)',
        linkText: 'var(--button-link-text, #0070c4)',
        linkTextHover: 'var(--button-link-text-hover, #0055a3)',
        subtleLinkText: 'var(--button-subtle-link-text, #2f3647)',
        subtleLinkTextHover: 'var(--button-subtle-link-text-hover, rgb(47 54 71 / .69))',
        dangerText: 'var(--button-danger-text, #fff)',
        dangerBackground: 'var(--button-danger-background, #e12635)',
        dangerBackgroundHover: 'var(--button-danger-background-hover, #af202b)',
        warningText: 'var(--button-warning-text, #2f3647)',
        warningBackground: 'var(--button-warning-background, #e99c3d)',
        warningBackgroundHover: 'var(--button-warning-background-hover, #e18428)',
        whiteText: 'var(--button-white-text, #0070c4)',
        whiteBackground: 'var(--button-white-background, #fff)',
        whiteBackgroundHover: 'var(--button-white-background-hover, #e0e1e5)',
    },
    card: {
        padding: 'var(--card-padding, 2rem)',
        borderRadius: 'var(--card-border-radius, .2rem)',
        borderWidth: 'var(--card-border-width, 1px)',
        border: 'var(--card-border, none)',
        borderHover: 'var(--card-border-hover, none)',
        borderActive: 'var(--card-border-active, none)',
        shadow: 'var(--card-shadow, 0 0 1px 0 #091e424f, 0 1px 1px 0 #091e4240)',
        shadowHover:
            'var(--card-shadow-hover, 0 0 1px 0 #091e424f, 0 3px 5px 0 #091e4233)',
        background: 'var(--card-background, rgb(from #fff r g b / 100%))',
    },
    charts: {
        '1': 'var(--charts-1, #0070c4)',
        '2': 'var(--charts-2, #fad846)',
        '3': 'var(--charts-3, #66cbe3)',
        '4': 'var(--charts-4, #f95463)',
        '5': 'var(--charts-5, #a58de7)',
        '6': 'var(--charts-6, #85f5da)',
        '7': 'var(--charts-7, #dc8ceb)',
        '8': 'var(--charts-8, #2eb8d8)',
        '9': 'var(--charts-9, #3aa926)',
        '10': 'var(--charts-10, #657fe5)',
        '11': 'var(--charts-11, #fad225)',
        '12': 'var(--charts-12, #e0d14d)',
        '13': 'var(--charts-13, #bd6fc8)',
        '14': 'var(--charts-14, #d4dc77)',
        '15': 'var(--charts-15, #f4c570)',
        '16': 'var(--charts-16, #a7e1ef)',
        '17': 'var(--charts-17, #fb7a86)',
        '18': 'var(--charts-18, #78c36c)',
        '19': 'var(--charts-19, #f3adfe)',
        '20': 'var(--charts-20, #1e8ca6)',
    },
    checkbox: {
        size: 'var(--checkbox-size, 1.4rem)',
        borderRadius: 'var(--checkbox-border-radius, .3rem)',
        borderWidth: 'var(--checkbox-border-width, 2px)',
        checkmarkSize: 'var(--checkbox-checkmark-size, 70%)',
        labelGap: 'var(--checkbox-label-gap, .5rem)',
        border: 'var(--checkbox-border, #a2a7b3)',
        background: 'var(--checkbox-background, #f7f8f9)',
        checkedBorder: 'var(--checkbox-checked-border, #0070c4)',
        checkedBackground: 'var(--checkbox-checked-background, #0070c4)',
        indeterminateBorder: 'var(--checkbox-indeterminate-border, #0070c4)',
        indeterminateBackground: 'var(--checkbox-indeterminate-background, #0070c4)',
        hoverBackground: 'var(--checkbox-hover-background, #e0e1e5)',
        hoverBorder: 'var(--checkbox-hover-border, #0055a3)',
        checkedHoverBackground: 'var(--checkbox-checked-hover-background, #0055a3)',
        checkedHoverBorder: 'var(--checkbox-checked-hover-border, #0055a3)',
        checkmark: 'var(--checkbox-checkmark, #fff)',
        disabledBorder: 'var(--checkbox-disabled-border, rgb(7 20 51 / .1))',
        disabledBackground: 'var(--checkbox-disabled-background, rgb(7 20 51 / .1))',
        disabledCheckedBorder:
            'var(--checkbox-disabled-checked-border, rgb(7 20 51 / .1))',
        disabledCheckedBackground:
            'var(--checkbox-disabled-checked-background, rgb(7 20 51 / .1))',
        disabledCheckmark: 'var(--checkbox-disabled-checkmark, rgb(7 20 51 / .28))',
        invalidBorder: 'var(--checkbox-invalid-border, #e12635)',
        invalidCheckedBorder: 'var(--checkbox-invalid-checked-border, #e12635)',
        invalidCheckedBackground: 'var(--checkbox-invalid-checked-background, #0070c4)',
    },
    checkboxgroup: {
        gap: 'var(--checkboxgroup-gap, .5rem)',
        labelGap: 'var(--checkboxgroup-label-gap, .5rem)',
    },
    color: {
        commonBlack: 'var(--color-common-black, #000)',
        commonBlackRgb: 'var(--color-common-black-rgb, 0 0 0)',
        commonWhite: 'var(--color-common-white, #fff)',
        commonWhiteRgb: 'var(--color-common-white-rgb, 255 255 255)',
        navy50: 'var(--color-navy-50, #e3e6eb)',
        navy50Rgb: 'var(--color-navy-50-rgb, 227 230 235)',
        navy100: 'var(--color-navy-100, #b9c0cf)',
        navy100Rgb: 'var(--color-navy-100-rgb, 185 192 207)',
        navy200: 'var(--color-navy-200, #8c97af)',
        navy200Rgb: 'var(--color-navy-200-rgb, 140 151 175)',
        navy300: 'var(--color-navy-300, #62718f)',
        navy300Rgb: 'var(--color-navy-300-rgb, 98 113 143)',
        navy400: 'var(--color-navy-400, #43557b)',
        navy400Rgb: 'var(--color-navy-400-rgb, 67 85 123)',
        navy500: 'var(--color-navy-500, #233a68)',
        navy500Rgb: 'var(--color-navy-500-rgb, 35 58 104)',
        navy600: 'var(--color-navy-600, #1d3461)',
        navy600Rgb: 'var(--color-navy-600-rgb, 29 52 97)',
        navy700: 'var(--color-navy-700, #152c56)',
        navy700Rgb: 'var(--color-navy-700-rgb, 21 44 86)',
        navy800: 'var(--color-navy-800, #0f234a)',
        navy800Rgb: 'var(--color-navy-800-rgb, 15 35 74)',
        navy900: 'var(--color-navy-900, #071433)',
        navy900Rgb: 'var(--color-navy-900-rgb, 7 20 51)',
        navy1000: 'var(--color-navy-1000, #1b212c)',
        navy1000Rgb: 'var(--color-navy-1000-rgb, 27 33 44)',
        bluecta50: 'var(--color-bluecta-50, #e3f2fd)',
        bluecta50Rgb: 'var(--color-bluecta-50-rgb, 227 242 253)',
        bluecta100: 'var(--color-bluecta-100, #bbdefb)',
        bluecta100Rgb: 'var(--color-bluecta-100-rgb, 187 222 251)',
        bluecta200: 'var(--color-bluecta-200, #90caf9)',
        bluecta200Rgb: 'var(--color-bluecta-200-rgb, 144 202 249)',
        bluecta300: 'var(--color-bluecta-300, #64b5f6)',
        bluecta300Rgb: 'var(--color-bluecta-300-rgb, 100 181 246)',
        bluecta400: 'var(--color-bluecta-400, #42a5f5)',
        bluecta400Rgb: 'var(--color-bluecta-400-rgb, 66 165 245)',
        bluecta500: 'var(--color-bluecta-500, #1693f2)',
        bluecta500Rgb: 'var(--color-bluecta-500-rgb, 22 147 242)',
        bluecta600: 'var(--color-bluecta-600, #0070c4)',
        bluecta600Rgb: 'var(--color-bluecta-600-rgb, 0 112 196)',
        bluecta700: 'var(--color-bluecta-700, #0055a3)',
        bluecta700Rgb: 'var(--color-bluecta-700-rgb, 0 85 163)',
        bluecta800: 'var(--color-bluecta-800, #003d82)',
        bluecta800Rgb: 'var(--color-bluecta-800-rgb, 0 61 130)',
        bluecta900: 'var(--color-bluecta-900, #002861)',
        bluecta900Rgb: 'var(--color-bluecta-900-rgb, 0 40 97)',
        turquoise100: 'var(--color-turquoise-100, #d3f0f7)',
        turquoise100Rgb: 'var(--color-turquoise-100-rgb, 211 240 247)',
        turquoise200: 'var(--color-turquoise-200, #bde8f3)',
        turquoise200Rgb: 'var(--color-turquoise-200-rgb, 189 232 243)',
        turquoise300: 'var(--color-turquoise-300, #a7e1ef)',
        turquoise300Rgb: 'var(--color-turquoise-300-rgb, 167 225 239)',
        turquoise400: 'var(--color-turquoise-400, #91d9eb)',
        turquoise400Rgb: 'var(--color-turquoise-400-rgb, 145 217 235)',
        turquoise500: 'var(--color-turquoise-500, #7bd2e7)',
        turquoise500Rgb: 'var(--color-turquoise-500-rgb, 123 210 231)',
        turquoise600: 'var(--color-turquoise-600, #66cbe3)',
        turquoise600Rgb: 'var(--color-turquoise-600-rgb, 102 203 227)',
        turquoise700: 'var(--color-turquoise-700, #2eb8d8)',
        turquoise700Rgb: 'var(--color-turquoise-700-rgb, 46 184 216)',
        turquoise800: 'var(--color-turquoise-800, #1e8ca6)',
        turquoise800Rgb: 'var(--color-turquoise-800-rgb, 30 140 166)',
        turquoise900: 'var(--color-turquoise-900, #145d6f)',
        turquoise900Rgb: 'var(--color-turquoise-900-rgb, 20 93 111)',
        turquoise1000: 'var(--color-turquoise-1000, #0a2e37)',
        turquoise1000Rgb: 'var(--color-turquoise-1000-rgb, 10 46 55)',
        red100: 'var(--color-red-100, #fee6e8)',
        red100Rgb: 'var(--color-red-100-rgb, 254 230 232)',
        red200: 'var(--color-red-200, #fdcbd1)',
        red200Rgb: 'var(--color-red-200-rgb, 253 203 209)',
        red300: 'var(--color-red-300, #fda2ad)',
        red300Rgb: 'var(--color-red-300-rgb, 253 162 173)',
        red400: 'var(--color-red-400, #fb7a86)',
        red400Rgb: 'var(--color-red-400-rgb, 251 122 134)',
        red500: 'var(--color-red-500, #f95463)',
        red500Rgb: 'var(--color-red-500-rgb, 249 84 99)',
        red600: 'var(--color-red-600, #f72f40)',
        red600Rgb: 'var(--color-red-600-rgb, 247 47 64)',
        red700: 'var(--color-red-700, #e12635)',
        red700Rgb: 'var(--color-red-700-rgb, 225 38 53)',
        red800: 'var(--color-red-800, #cb222f)',
        red800Rgb: 'var(--color-red-800-rgb, 203 34 47)',
        red900: 'var(--color-red-900, #af202b)',
        red900Rgb: 'var(--color-red-900-rgb, 175 32 43)',
        red1000: 'var(--color-red-1000, #931d26)',
        red1000Rgb: 'var(--color-red-1000-rgb, 147 29 38)',
        orange100: 'var(--color-orange-100, #fbedcb)',
        orange100Rgb: 'var(--color-orange-100-rgb, 251 237 203)',
        orange200: 'var(--color-orange-200, #f9e3ab)',
        orange200Rgb: 'var(--color-orange-200-rgb, 249 227 171)',
        orange300: 'var(--color-orange-300, #f7d58d)',
        orange300Rgb: 'var(--color-orange-300-rgb, 247 213 141)',
        orange400: 'var(--color-orange-400, #f4c570)',
        orange400Rgb: 'var(--color-orange-400-rgb, 244 197 112)',
        orange500: 'var(--color-orange-500, #f0b355)',
        orange500Rgb: 'var(--color-orange-500-rgb, 240 179 85)',
        orange600: 'var(--color-orange-600, #e99c3d)',
        orange600Rgb: 'var(--color-orange-600-rgb, 233 156 61)',
        orange700: 'var(--color-orange-700, #e18428)',
        orange700Rgb: 'var(--color-orange-700-rgb, 225 132 40)',
        orange800: 'var(--color-orange-800, #d86a15)',
        orange800Rgb: 'var(--color-orange-800-rgb, 216 106 21)',
        orange900: 'var(--color-orange-900, #ce4c00)',
        orange900Rgb: 'var(--color-orange-900-rgb, 206 76 0)',
        orange1000: 'var(--color-orange-1000, #a33c00)',
        orange1000Rgb: 'var(--color-orange-1000-rgb, 163 60 0)',
        yellow100: 'var(--color-yellow-100, #fdf4cd)',
        yellow100Rgb: 'var(--color-yellow-100-rgb, 253 244 205)',
        yellow200: 'var(--color-yellow-200, #fdedab)',
        yellow200Rgb: 'var(--color-yellow-200-rgb, 253 237 171)',
        yellow300: 'var(--color-yellow-300, #fce689)',
        yellow300Rgb: 'var(--color-yellow-300-rgb, 252 230 137)',
        yellow400: 'var(--color-yellow-400, #fbdf68)',
        yellow400Rgb: 'var(--color-yellow-400-rgb, 251 223 104)',
        yellow500: 'var(--color-yellow-500, #fad846)',
        yellow500Rgb: 'var(--color-yellow-500-rgb, 250 216 70)',
        yellow600: 'var(--color-yellow-600, #fad225)',
        yellow600Rgb: 'var(--color-yellow-600-rgb, 250 210 37)',
        yellow700: 'var(--color-yellow-700, #e0b705)',
        yellow700Rgb: 'var(--color-yellow-700-rgb, 224 183 5)',
        yellow800: 'var(--color-yellow-800, #a88903)',
        yellow800Rgb: 'var(--color-yellow-800-rgb, 168 137 3)',
        yellow900: 'var(--color-yellow-900, #705b02)',
        yellow900Rgb: 'var(--color-yellow-900-rgb, 112 91 2)',
        yellow1000: 'var(--color-yellow-1000, #382d01)',
        yellow1000Rgb: 'var(--color-yellow-1000-rgb, 56 45 1)',
        grey25: 'var(--color-grey-25, #f7f8f9)',
        grey25Rgb: 'var(--color-grey-25-rgb, 247 248 249)',
        grey50: 'var(--color-grey-50, #eff1f3)',
        grey50Rgb: 'var(--color-grey-50-rgb, 239 241 243)',
        grey100: 'var(--color-grey-100, #e0e1e5)',
        grey100Rgb: 'var(--color-grey-100-rgb, 224 225 229)',
        grey200: 'var(--color-grey-200, #d0d2d8)',
        grey200Rgb: 'var(--color-grey-200-rgb, 208 210 216)',
        grey300: 'var(--color-grey-300, #c1c4cc)',
        grey300Rgb: 'var(--color-grey-300-rgb, 193 196 204)',
        grey400: 'var(--color-grey-400, #a2a7b3)',
        grey400Rgb: 'var(--color-grey-400-rgb, 162 167 179)',
        grey500: 'var(--color-grey-500, #9298a6)',
        grey500Rgb: 'var(--color-grey-500-rgb, 146 152 166)',
        grey600: 'var(--color-grey-600, #838a99)',
        grey600Rgb: 'var(--color-grey-600-rgb, 131 138 153)',
        grey650: 'var(--color-grey-650, #737988)',
        grey650Rgb: 'var(--color-grey-650-rgb, 115 121 136)',
        grey700: 'var(--color-grey-700, #63687c)',
        grey700Rgb: 'var(--color-grey-700-rgb, 99 104 124)',
        grey750: 'var(--color-grey-750, #545b71)',
        grey750Rgb: 'var(--color-grey-750-rgb, 84 91 113)',
        grey800: 'var(--color-grey-800, #454f66)',
        grey800Rgb: 'var(--color-grey-800-rgb, 69 79 102)',
        grey850: 'var(--color-grey-850, #3a4256)',
        grey850Rgb: 'var(--color-grey-850-rgb, 58 66 86)',
        grey900: 'var(--color-grey-900, #2f3647)',
        grey900Rgb: 'var(--color-grey-900-rgb, 47 54 71)',
        grey950: 'var(--color-grey-950, #242936)',
        grey950Rgb: 'var(--color-grey-950-rgb, 36 41 54)',
        grey1000: 'var(--color-grey-1000, #1a1e28)',
        grey1000Rgb: 'var(--color-grey-1000-rgb, 26 30 40)',
        green100: 'var(--color-green-100, #e7f4e5)',
        green100Rgb: 'var(--color-green-100-rgb, 231 244 229)',
        green200: 'var(--color-green-200, #c5e4bf)',
        green200Rgb: 'var(--color-green-200-rgb, 197 228 191)',
        green300: 'var(--color-green-300, #a0d396)',
        green300Rgb: 'var(--color-green-300-rgb, 160 211 150)',
        green400: 'var(--color-green-400, #78c36c)',
        green400Rgb: 'var(--color-green-400-rgb, 120 195 108)',
        green500: 'var(--color-green-500, #5ab64b)',
        green500Rgb: 'var(--color-green-500-rgb, 90 182 75)',
        green600: 'var(--color-green-600, #3aa926)',
        green600Rgb: 'var(--color-green-600-rgb, 58 169 38)',
        green700: 'var(--color-green-700, #309b1d)',
        green700Rgb: 'var(--color-green-700-rgb, 48 155 29)',
        green800: 'var(--color-green-800, #228910)',
        green800Rgb: 'var(--color-green-800-rgb, 34 137 16)',
        green900: 'var(--color-green-900, #117800)',
        green900Rgb: 'var(--color-green-900-rgb, 17 120 0)',
        green1000: 'var(--color-green-1000, #005a00)',
        green1000Rgb: 'var(--color-green-1000-rgb, 0 90 0)',
        blue50: 'var(--color-blue-50, #ebf2f8)',
        blue50Rgb: 'var(--color-blue-50-rgb, 235 242 248)',
        blue100: 'var(--color-blue-100, #d1e3ef)',
        blue100Rgb: 'var(--color-blue-100-rgb, 209 227 239)',
        blue200: 'var(--color-blue-200, #a3c7df)',
        blue200Rgb: 'var(--color-blue-200-rgb, 163 199 223)',
        blue300: 'var(--color-blue-300, #75abcf)',
        blue300Rgb: 'var(--color-blue-300-rgb, 117 171 207)',
        blue400: 'var(--color-blue-400, #4b8fbf)',
        blue400Rgb: 'var(--color-blue-400-rgb, 75 143 191)',
        blue500: 'var(--color-blue-500, #2f73a7)',
        blue500Rgb: 'var(--color-blue-500-rgb, 47 115 167)',
        blue600: 'var(--color-blue-600, #27568a)',
        blue600Rgb: 'var(--color-blue-600-rgb, 39 86 138)',
        blue700: 'var(--color-blue-700, #1e416d)',
        blue700Rgb: 'var(--color-blue-700-rgb, 30 65 109)',
        blue800: 'var(--color-blue-800, #162d50)',
        blue800Rgb: 'var(--color-blue-800-rgb, 22 45 80)',
        blue900: 'var(--color-blue-900, #0e1933)',
        blue900Rgb: 'var(--color-blue-900-rgb, 14 25 51)',
        purple50: 'var(--color-purple-50, #eae6ff)',
        purple50Rgb: 'var(--color-purple-50-rgb, 234 230 255)',
        purple100: 'var(--color-purple-100, #bcb1ed)',
        purple100Rgb: 'var(--color-purple-100-rgb, 188 177 237)',
        purple200: 'var(--color-purple-200, #a69ae2)',
        purple200Rgb: 'var(--color-purple-200-rgb, 166 154 226)',
        purple300: 'var(--color-purple-300, #9082d6)',
        purple300Rgb: 'var(--color-purple-300-rgb, 144 130 214)',
        purple400: 'var(--color-purple-400, #7a6bcb)',
        purple400Rgb: 'var(--color-purple-400-rgb, 122 107 203)',
        purple500: 'var(--color-purple-500, #6554c0)',
        purple500Rgb: 'var(--color-purple-500-rgb, 101 84 192)',
        purple600: 'var(--color-purple-600, #5f49b9)',
        purple600Rgb: 'var(--color-purple-600-rgb, 95 73 185)',
        purple700: 'var(--color-purple-700, #5542ad)',
        purple700Rgb: 'var(--color-purple-700-rgb, 85 66 173)',
        purple800: 'var(--color-purple-800, #4a3ba0)',
        purple800Rgb: 'var(--color-purple-800-rgb, 74 59 160)',
        purple900: 'var(--color-purple-900, #403294)',
        purple900Rgb: 'var(--color-purple-900-rgb, 64 50 148)',
    },
    comment: {
        blockquoteBackground: 'var(--comment-blockquote-background, #ffffff40)',
    },
    custom: {
        marker1: 'var(--custom-marker-1, #607d8b)',
        marker2: 'var(--custom-marker-2, #4caf50)',
        marker3: 'var(--custom-marker-3, #795548)',
        marker4: 'var(--custom-marker-4, #80d8ff)',
        faultMarker: 'var(--custom-fault-marker, #2f3647)',
    },
    divider: {
        default: 'var(--divider-default, rgb(7 20 51 / .14))',
        dark: 'var(--divider-dark, rgb(7 20 51 / .24))',
    },
    elevation: {
        '100': 'var(--elevation-100, 0 0 1px 0 #091e424f, 0 1px 1px 0 #091e4240)',
        '200': 'var(--elevation-200, 0 0 1px 0 #091e424f, 0 3px 5px 0 #091e4233)',
        '300': 'var(--elevation-300, 0 0 1px 0 #091e424f, 0 0 12px 0 #091e4226)',
        '400': 'var(--elevation-400, 0 0 1px 0 #091e424f, 0 10px 18px 0 #091e4226)',
        '500': 'var(--elevation-500, 0 0 1px 0 #091e424f, 0 18px 28px 0 #091e4226)',
    },
    error: {
        default: 'var(--error-default, #e12635)',
        light: 'var(--error-light, #f72f40)',
        dark: 'var(--error-dark, #af202b)',
        contrast: 'var(--error-contrast, #fff)',
        hover: 'var(--error-hover, #af202b)',
        active: 'var(--error-active, #af202b)',
    },
    folder: {
        icon: 'var(--folder-icon, #f0b355)',
    },
    font: {
        familyBase:
            'var(--font-family-base, REM, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif)',
        familyMono:
            'var(--font-family-mono, "Roboto Mono", ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono", monospace)',
        weightLight: 'var(--font-weight-light, 300)',
        weightRegular: 'var(--font-weight-regular, 400)',
        weightMedium: 'var(--font-weight-medium, 500)',
        sizeXs: 'var(--font-size-xs, 1.2rem)',
        sizeSm: 'var(--font-size-sm, 1.4rem)',
        sizeMd: 'var(--font-size-md, 1.7rem)',
        sizeLg: 'var(--font-size-lg, 2rem)',
        sizeXl: 'var(--font-size-xl, 2.4rem)',
        size2xl: 'var(--font-size-2xl, 2.9rem)',
        size3xl: 'var(--font-size-3xl, 3.5rem)',
        sizeBase: 'var(--font-size-base, 1.4rem)',
        weightBase: 'var(--font-weight-base, 300)',
    },
    foreground: {
        inverse: 'var(--foreground-inverse, #fff)',
    },
    form: {
        fieldSpacing: 'var(--form-field-spacing, .5rem)',
        errorIconGap: 'var(--form-error-icon-gap, .5rem)',
    },
    grey: {
        default: 'var(--grey-default, #e0e1e5)',
        light: 'var(--grey-light, #f7f8f9)',
        dark: 'var(--grey-dark, #c1c4cc)',
        contrast: 'var(--grey-contrast, #2f3647)',
    },
    health: {
        rangeUnspecified: 'var(--health-range-unspecified, #c1c4cc)',
        rangeOff: 'var(--health-range-off, #2f3647)',
        rangeHealthy: 'var(--health-range-healthy, #228910)',
        rangeFaultDeveloping: 'var(--health-range-fault-developing, #e99c3d)',
        rangeUnhealthy: 'var(--health-range-unhealthy, #e12635)',
    },
    history: {
        issueBackground: 'var(--history-issue-background, #fbedcb)',
        issueIcon: 'var(--history-issue-icon, #a33c00)',
        taskBackground: 'var(--history-task-background, #e7f4e5)',
        taskIcon: 'var(--history-task-icon, #117800)',
        alertBackground: 'var(--history-alert-background, #fee6e8)',
        alertIcon: 'var(--history-alert-icon, #af202b)',
    },
    icon: {
        actionActive: 'var(--icon-action-active, rgb(7 20 51 / .72))',
        actionHover: 'var(--icon-action-hover, rgb(7 20 51 / .86))',
        actionSelected: 'var(--icon-action-selected, rgb(7 20 51 / 1))',
        actionFocus: 'var(--icon-action-focus, rgb(7 20 51 / .94))',
        onColor: 'var(--icon-on-color, #fff)',
        default: 'var(--icon-default, #8c97af)',
        secondary: 'var(--icon-secondary, #63687c)',
        primary: 'var(--icon-primary, #3a4256)',
        positive: 'var(--icon-positive, #5ab64b)',
    },
    indicator: {
        thresholdOff: 'var(--indicator-threshold-off, #c1c4cc)',
        thresholdAlarm: 'var(--indicator-threshold-alarm, #f72f40)',
        thresholdWarning: 'var(--indicator-threshold-warning, #e18428)',
        thresholdCriticalAlarm: 'var(--indicator-threshold-critical-alarm, #af202b)',
    },
    info: {
        default: 'var(--info-default, #0070c4)',
        light: 'var(--info-light, #1693f2)',
        dark: 'var(--info-dark, #0055a3)',
        contrast: 'var(--info-contrast, #fff)',
        hover: 'var(--info-hover, #0055a3)',
        active: 'var(--info-active, #0055a3)',
    },
    input: {
        padding: 'var(--input-padding, 1rem)',
        borderWidth: 'var(--input-border-width, 1px)',
        borderWidthFocus: 'var(--input-border-width-focus, 2px)',
        labelGap: 'var(--input-label-gap, .5rem)',
        background: 'var(--input-background, rgb(7 20 51 / .04))',
        border: 'var(--input-border, rgb(7 20 51 / .13))',
        borderHover: 'var(--input-border-hover, #c1c4cc)',
        borderFocus: 'var(--input-border-focus, #0070c4)',
        borderError: 'var(--input-border-error, #e12635)',
        borderSuccess: 'var(--input-border-success, #228910)',
        borderValid: 'var(--input-border-valid, #228910)',
        placeholder: 'var(--input-placeholder, rgb(47 54 71 / .5))',
    },
    label: {
        fontSize: 'var(--label-font-size, 1.4rem)',
        fontWeight: 'var(--label-font-weight, 500)',
    },
    line: {
        heightTight: 'var(--line-height-tight, 1.28)',
        heightNormal: 'var(--line-height-normal, 1.33)',
        heightRelaxed: 'var(--line-height-relaxed, 1.5)',
        heightBase: 'var(--line-height-base, 1.28)',
    },
    lozenge: {
        blueBackground: 'var(--lozenge-blue-background, #0055a3)',
        blueColor: 'var(--lozenge-blue-color, #ffffff)',
        greenBackground: 'var(--lozenge-green-background, #228910)',
        greenColor: 'var(--lozenge-green-color, #ffffff)',
        purpleBackground: 'var(--lozenge-purple-background, #6554c0)',
        purpleColor: 'var(--lozenge-purple-color, #ffffff)',
        turquoiseBackground: 'var(--lozenge-turquoise-background, #1e8ca6)',
        turquoiseColor: 'var(--lozenge-turquoise-color, #ffffff)',
        red1Background: 'var(--lozenge-red-1-background, #e12635)',
        red1Color: 'var(--lozenge-red-1-color, #ffffff)',
        red2Background: 'var(--lozenge-red-2-background, #af202b)',
        red2Color: 'var(--lozenge-red-2-color, #ffffff)',
        orange1Background: 'var(--lozenge-orange-1-background, #e99c3d)',
        orange1Color: 'var(--lozenge-orange-1-color, #ffffff)',
        orange2Background: 'var(--lozenge-orange-2-background, #e18428)',
        orange2Color: 'var(--lozenge-orange-2-color, #ffffff)',
        orange3Background: 'var(--lozenge-orange-3-background, #d86a15)',
        orange3Color: 'var(--lozenge-orange-3-color, #ffffff)',
        grey1Background: 'var(--lozenge-grey-1-background, #e0e1e5)',
        grey1Color: 'var(--lozenge-grey-1-color, #000000)',
        grey2Background: 'var(--lozenge-grey-2-background, #d0d2d8)',
        grey2Color: 'var(--lozenge-grey-2-color, #000000)',
        grey3Background: 'var(--lozenge-grey-3-background, #a2a7b3)',
        grey3Color: 'var(--lozenge-grey-3-color, #000000)',
        grey4Background: 'var(--lozenge-grey-4-background, #63687c)',
        grey4Color: 'var(--lozenge-grey-4-color, #ffffff)',
        grey5Background: 'var(--lozenge-grey-5-background, #3a4256)',
        grey5Color: 'var(--lozenge-grey-5-color, #ffffff)',
        removeBackgroundHover: 'var(--lozenge-remove-background-hover, #ffbdad)',
        removeIconHover: 'var(--lozenge-remove-icon-hover, #de350b)',
    },
    metric: {
        newBackground: 'var(--metric-new-background, #d3f0f7)',
        newIcon: 'var(--metric-new-icon, #1e8ca6)',
        openBackground: 'var(--metric-open-background, #e7f4e5)',
        openIcon: 'var(--metric-open-icon, #228910)',
        resolvedBackground: 'var(--metric-resolved-background, #eae6ff)',
        resolvedIcon: 'var(--metric-resolved-icon, #6554c0)',
        draftBackground: 'var(--metric-draft-background, #e0e1e5)',
        draftIcon: 'var(--metric-draft-icon, #63687c)',
        daysBackground: 'var(--metric-days-background, #fbedcb)',
        daysIcon: 'var(--metric-days-icon, #e18428)',
        downtimeBackground: 'var(--metric-downtime-background, #e3f2fd)',
        downtimeIcon: 'var(--metric-downtime-icon, #0070c4)',
        savingsBackground: 'var(--metric-savings-background, #e7f4e5)',
        savingsIcon: 'var(--metric-savings-icon, #228910)',
        severeBackground: 'var(--metric-severe-background, #fee6e8)',
        severeIcon: 'var(--metric-severe-icon, #e12635)',
    },
    misc: {
        favorite: 'var(--favorite, #f29d01)',
    },
    modal: {
        borderRadius: 'var(--modal-border-radius, .8rem)',
    },
    nav: {
        primaryBackground: 'var(--nav-primary-background, rgb(255 255 255 / .6))',
        secondaryBackground: 'var(--nav-secondary-background, rgb(255 255 255 / .6))',
        secondarySelected: 'var(--nav-secondary-selected, #2f3647)',
        secondaryItemSelected: 'var(--nav-secondary-item-selected, rgb(7 20 51 / .08))',
        border: 'var(--nav-border, rgb(7 20 51 / .14))',
        text: 'var(--nav-text, #2f3647)',
        icon: 'var(--nav-icon, #2f3647)',
        chevron: 'var(--nav-chevron, rgb(7 20 51 / .72))',
        textSelected: 'var(--nav-text-selected, #fff)',
        hoverBackground: 'var(--nav-hover-background, rgb(7 20 51 / .04))',
        popupBackground: 'var(--nav-popup-background, #fff)',
        popupShadow:
            'var(--nav-popup-shadow, 0 0 1px 0 #091e424f, 0 10px 18px 0 #091e4226)',
        itemSize: 'var(--nav-item-size, 5.6rem)',
        expandedWidth: 'var(--nav-expanded-width, 30rem)',
    },
    neutral: {
        default: 'var(--neutral-default, #e0e1e5)',
        light: 'var(--neutral-light, #f7f8f9)',
        dark: 'var(--neutral-dark, #c1c4cc)',
        contrast: 'var(--neutral-contrast, #2f3647)',
        hover: 'var(--neutral-hover, #e0e1e5)',
        active: 'var(--neutral-active, #c1c4cc)',
    },
    on: {
        primary: 'var(--on-primary, #fff)',
        error: 'var(--on-error, #fff)',
        success: 'var(--on-success, #fff)',
        warning: 'var(--on-warning, #fff)',
    },
    overlay: {
        default: 'var(--overlay-default, rgb(0 0 0 / .6))',
        light: 'var(--overlay-light, rgb(0 0 0 / .4))',
    },
    pagelayout: {
        compactPadding: 'var(--pagelayout-compact-padding, 2rem)',
        overviewPadding: 'var(--pagelayout-overview-padding, 5rem 2rem)',
        overviewPaddingLg: 'var(--pagelayout-overview-padding-lg, 5rem 5rem 7.5rem 5rem)',
        overviewPaddingXl: 'var(--pagelayout-overview-padding-xl, 5rem)',
        taskSpacing: 'var(--pagelayout-task-spacing, 2rem)',
    },
    popup: {
        arrowStroke: 'var(--popup-arrow-stroke, rgb(9 30 66 / 0.05))',
        arrowShadow: 'var(--popup-arrow-shadow, 0 2px 3px rgb(9 30 66 / 0.15))',
        border: 'var(--popup-border, none)',
    },
    primary: {
        default: 'var(--primary-default, #0070c4)',
        light: 'var(--primary-light, #0070c4)',
        dark: 'var(--primary-dark, #0055a3)',
        contrast: 'var(--primary-contrast, #fff)',
        hover: 'var(--primary-hover, #0055a3)',
        active: 'var(--primary-active, #0055a3)',
    },
    priority: {
        '1': 'var(--priority-1, #273d5a)',
        '2': 'var(--priority-2, #6c7c97)',
        '3': 'var(--priority-3, #95a7c1)',
        '4': 'var(--priority-4, #dfe1e6)',
        '5': 'var(--priority-5, #e9ecf2)',
    },
    radio: {
        border: 'var(--radio-border, #c1c4cc)',
        background: 'var(--radio-background, #fff)',
        backgroundInvalid: 'var(--radio-background-invalid, #f7f8f9)',
        hoverBackground: 'var(--radio-hover-background, #e0e1e5)',
        activeBackground: 'var(--radio-active-background, #e0e1e5)',
        activeBackgroundInvalid: 'var(--radio-active-background-invalid, #f7f8f9)',
        activeBorderInvalid: 'var(--radio-active-border-invalid, #e0e1e5)',
        focusBackground: 'var(--radio-focus-background, #f7f8f9)',
        disabledBackground: 'var(--radio-disabled-background, rgb(7 20 51 / .1))',
        disabledBorder: 'var(--radio-disabled-border, rgb(7 20 51 / .1))',
        checkedBackground: 'var(--radio-checked-background, #0070c4)',
        checkedBorder: 'var(--radio-checked-border, #0070c4)',
        checkedDot: 'var(--radio-checked-dot, #fff)',
        checkedBackgroundInvalid: 'var(--radio-checked-background-invalid, #0055a3)',
        checkedHoverBackground: 'var(--radio-checked-hover-background, #0055a3)',
        checkedHoverBackgroundInvalid:
            'var(--radio-checked-hover-background-invalid, #0070c4)',
        checkedFocusBackground: 'var(--radio-checked-focus-background, #0055a3)',
        checkedDisabledBackground:
            'var(--radio-checked-disabled-background, rgb(7 20 51 / .1))',
        checkedDisabledDot: 'var(--radio-checked-disabled-dot, rgb(7 20 51 / .28))',
    },
    radiobutton: {
        padding: 'var(--radiobutton-padding, 1rem)',
        indicatorSize: 'var(--radiobutton-indicator-size, 1.5rem)',
        indicatorDotSize: 'var(--radiobutton-indicator-dot-size, .5rem)',
        fontSize: 'var(--radiobutton-font-size, 1.4rem)',
        fontWeight: 'var(--radiobutton-font-weight, 500)',
        borderRadius: 'var(--radiobutton-border-radius, 99.9rem)',
        borderWidth: 'var(--radiobutton-border-width, 2px)',
        labelGap: 'var(--radiobutton-label-gap, .75rem)',
        groupGap: 'var(--radiobutton-group-gap, 1rem)',
        tilePaddingSm: 'var(--radiobutton-tile-padding-sm, .75rem)',
        tileIndicatorSizeSm: 'var(--radiobutton-tile-indicator-size-sm, 1rem)',
        tileIndicatorBorderSm: 'var(--radiobutton-tile-indicator-border-sm, .35rem)',
        tileIndicatorMarginSm: 'var(--radiobutton-tile-indicator-margin-sm, .5rem)',
        tilePaddingLg: 'var(--radiobutton-tile-padding-lg, 2rem)',
        tileIndicatorSizeLg: 'var(--radiobutton-tile-indicator-size-lg, 1.6rem)',
        tileIndicatorBorderLg: 'var(--radiobutton-tile-indicator-border-lg, .6rem)',
        tileIndicatorMarginLg: 'var(--radiobutton-tile-indicator-margin-lg, 1rem)',
    },
    radius: {
        sm: 'var(--radius-sm, .4rem)',
        default: 'var(--radius-default, .8rem)',
        lg: 'var(--radius-lg, 1.2rem)',
        full: 'var(--radius-full, 999.9rem)',
    },
    resolution: {
        resolved: 'var(--resolution-resolved, #5243aa)',
        removed: 'var(--resolution-removed, #e12635)',
    },
    savings: {
        green: 'var(--savings-green, #228910)',
    },
    secondary: {
        default: 'var(--secondary-default, #b9c0cf)',
        light: 'var(--secondary-light, #e3e6eb)',
        dark: 'var(--secondary-dark, #8c97af)',
        contrast: 'var(--secondary-contrast, #071433)',
        hover: 'var(--secondary-hover, #e3e6eb)',
        active: 'var(--secondary-active, #8c97af)',
    },
    select: {
        arrowOffset: 'var(--select-arrow-offset, .7em)',
        arrowSize: 'var(--select-arrow-size, .9em)',
        padding: 'var(--select-padding, 1rem)',
        arrowColor: 'var(--select-arrow-color, rgb(7 20 51 / .72))',
    },
    severity: {
        critical: 'var(--severity-critical, #af202b)',
        alarm: 'var(--severity-alarm, #e12635)',
        moderate: 'var(--severity-moderate, #d86a15)',
        low: 'var(--severity-low, #e99c3d)',
    },
    shadow: {
        modal: 'var(--shadow-modal, 0 0 1px 0 #091e424f, 0 3px 5px 0 #091e4233)',
        toast: 'var(--shadow-toast, 0 0 1px 0 #091e424f, 0 0 12px 0 #091e4226)',
    },
    skeleton: {
        base: 'var(--skeleton-base, #e0e1e5)',
        highlight: 'var(--skeleton-highlight, #eff1f3)',
    },
    status: {
        draft: 'var(--status-draft, #e0e1e5)',
        draftText: 'var(--status-draft-text, rgb(47 54 71 / .69))',
        new: 'var(--status-new, #1e8ca6)',
        open: 'var(--status-open, #228910)',
        closed: 'var(--status-closed, #3a4256)',
        wontFix: 'var(--status-wont-fix, #0070c4)',
        notAnIssue: 'var(--status-not-an-issue, #a2a7b3)',
        removed: 'var(--status-removed, #e12635)',
    },
    success: {
        default: 'var(--success-default, #228910)',
        light: 'var(--success-light, #a0d396)',
        dark: 'var(--success-dark, #117800)',
        contrast: 'var(--success-contrast, #fff)',
        hover: 'var(--success-hover, #117800)',
        active: 'var(--success-active, #117800)',
    },
    surface: {
        default: 'var(--surface-default, #fff)',
        raised: 'var(--surface-raised, #fff)',
        overlay: 'var(--surface-overlay, #fff)',
        sunken: 'var(--surface-sunken, #fff)',
        placeholder: 'var(--surface-placeholder, #a2a7b3)',
        subtle: 'var(--surface-subtle, #f7f8f9)',
        secondary: 'var(--surface-secondary, #e0e1e5)',
        dark: 'var(--surface-dark, #3a4256)',
    },
    tertiary: {
        default: 'var(--tertiary-default, #66cbe3)',
        light: 'var(--tertiary-light, #d3f0f7)',
        dark: 'var(--tertiary-dark, #2eb8d8)',
        contrast: 'var(--tertiary-contrast, #fff)',
        hover: 'var(--tertiary-hover, #2eb8d8)',
        active: 'var(--tertiary-active, #2eb8d8)',
    },
    tertiarybar: {
        height: 'var(--tertiarybar-height, 6rem)',
        paddingX: 'var(--tertiarybar-padding-x, 2rem)',
        itemPaddingX: 'var(--tertiarybar-item-padding-x, 2rem)',
    },
    text: {
        primary: 'var(--text-primary, #2f3647)',
        secondary: 'var(--text-secondary, rgb(47 54 71 / .69))',
        tertiary: 'var(--text-tertiary, rgb(47 54 71 / .5))',
        disabled: 'var(--text-disabled, rgb(47 54 71 / .43))',
        inverse: 'var(--text-inverse, #fff)',
        error: 'var(--text-error, #e12635)',
        warning: 'var(--text-warning, #ce4c00)',
        success: 'var(--text-success, #228910)',
        info: 'var(--text-info, #0070c4)',
        link: 'var(--text-link, #0070c4)',
        linkHover: 'var(--text-link-hover, #0055a3)',
        onColor: 'var(--text-on-color, #fff)',
        primaryInverse: 'var(--text-primary-inverse, #2f3647)',
    },
    timeseries: {
        background: 'var(--timeseries-background, #fff)',
        axis: 'var(--timeseries-axis, #838a99)',
        grid: 'var(--timeseries-grid, #d0d2d8)',
    },
    toggle: {
        width: 'var(--toggle-width, 3rem)',
        height: 'var(--toggle-height, 1.6rem)',
        padding: 'var(--toggle-padding, .2rem)',
        borderSize: 'var(--toggle-border-size, 0rem)',
        borderRadius: 'var(--toggle-border-radius, 999.9rem)',
        knobWidth: 'var(--toggle-knob-width, 1.2rem)',
        knobHeight: 'var(--toggle-knob-height, 1.2rem)',
        knobBorderRadius: 'var(--toggle-knob-border-radius, 50%)',
        labelGap: 'var(--toggle-label-gap, .5rem)',
        iconScale: 'var(--toggle-icon-scale, .65)',
        iconOffset: 'var(--toggle-icon-offset, .4rem)',
        iconOffsetY: 'var(--toggle-icon-offset-y, .4rem)',
        crossScale: 'var(--toggle-cross-scale, .65)',
        crossOffset: 'var(--toggle-cross-offset, -.1rem)',
        crossOffsetY: 'var(--toggle-cross-offset-y, .45rem)',
        background: 'var(--toggle-background, rgb(7 20 51 / .28))',
        border: 'var(--toggle-border, rgb(7 20 51 / .14))',
        knob: 'var(--toggle-knob, #fff)',
        knobShadow:
            'var(--toggle-knob-shadow, 0px 1px 2px rgb(0 0 0 / .3), 0px 0px 5px rgb(var(--color-common-black-rgb) / .1))',
        checkedBackground: 'var(--toggle-checked-background, #0070c4)',
        hoverBorder: 'var(--toggle-hover-border, #0070c4)',
    },
    transition: {
        duration: 'var(--transition-duration, .2s)',
        durationFast: 'var(--transition-duration-fast, .15s)',
        easing: 'var(--transition-easing, ease-in-out)',
    },
    trend: {
        indicators1: 'var(--trend-indicators-1, #0070c4)',
        indicators2: 'var(--trend-indicators-2, #ffc107)',
        indicators3: 'var(--trend-indicators-3, #d10d54)',
        indicators4: 'var(--trend-indicators-4, #6f3fc9)',
        indicators5: 'var(--trend-indicators-5, #1de9b6)',
        indicators6: 'var(--trend-indicators-6, #c750df)',
        indicators7: 'var(--trend-indicators-7, #009ce1)',
        indicators8: 'var(--trend-indicators-8, #48a748)',
        indicators9: 'var(--trend-indicators-9, #1740d9)',
        indicators10: 'var(--trend-indicators-10, #f29d01)',
        indicators11: 'var(--trend-indicators-11, #ceb900)',
        indicators12: 'var(--trend-indicators-12, #9c27b0)',
        indicators13: 'var(--trend-indicators-13, #00bcd4)',
        indicators14: 'var(--trend-indicators-14, #c2d035)',
        indicators15: 'var(--trend-indicators-15, #fe5918)',
        indicators16: 'var(--trend-indicators-16, #52def0)',
        indicators17: 'var(--trend-indicators-17, #ff80ab)',
        indicators18: 'var(--trend-indicators-18, #8bc34a)',
        indicators19: 'var(--trend-indicators-19, #ea80fc)',
        indicators20: 'var(--trend-indicators-20, #006f7d)',
    },
    warning: {
        default: 'var(--warning-default, #e99c3d)',
        light: 'var(--warning-light, #f0b355)',
        dark: 'var(--warning-dark, #e18428)',
        contrast: 'var(--warning-contrast, #2f3647)',
        hover: 'var(--warning-hover, #e18428)',
        active: 'var(--warning-active, #e18428)',
    },
} as const;

export type SdwebTokens = typeof sdwebTokens;
